export const API_URL = process.env.REACT_APP_API_URL;
 
export const APP_URL = process.env.REACT_APP_URL;
 
 
export const LOGINAPP_API_URL = process.env.REACT_APP_LOGINAPP_API_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
 
export const APP_ID =process.env.REACT_APP_DASHBOARD_APP_ID;
 
 
